"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var account_1 = tslib_1.__importDefault(require("./account"));
var series_1 = tslib_1.__importDefault(require("./series"));
var location_1 = tslib_1.__importDefault(require("./location"));
var set_1 = tslib_1.__importDefault(require("./set"));
var BudgetLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(BudgetLineResource, _super);
    function BudgetLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BudgetLineResource.endpoint = '/budgetlines';
    // static MODEL_NAME = 'budgetline' // Use VarianceResource unless you want to pre-calculate costs
    BudgetLineResource.related = {
        account: account_1.default,
        series: series_1.default,
        location: location_1.default,
        set: set_1.default,
    };
    return BudgetLineResource;
}(base_1.default));
exports.default = BudgetLineResource;
//# sourceMappingURL=budgetline.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/budgetline.js
// module id = kYzn
// module chunks = 0